import { call, put, select } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client';
import { actions } from '../../Stream';
import { getCurrentMediaSource, getNonManageablePrependedGallectionsCount, getCurrentFolderId, getGrusername } from '../selectors';
import { getGallectionStreamId, getGallectionType } from '../helpers';
function* moveGallectionToPosition(action) {
    const { folderId, position, moveType } = action.payload;
    const username = yield select(getGrusername);
    const mediaSource = yield select(getCurrentMediaSource);
    const currentFolderId = yield select(getCurrentFolderId);
    const nonManageablePrependedGallectionsCount = yield select(getNonManageablePrependedGallectionsCount);
    const streamId = getGallectionStreamId(mediaSource, currentFolderId);
    if (!moveType || moveType === 'streamOnly') {
        yield put(actions.moveItem({
            streamId,
            item: folderId,
            position
        }));
    }
    if (!moveType || moveType === 'papiOnly') {
        var _getGallectionType;
        const params = {
            username,
            folderid: folderId,
            type: (_getGallectionType = getGallectionType(mediaSource)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
            position: position - nonManageablePrependedGallectionsCount
        };
        yield call(requestPuppy, {
            method: 'post',
            url: 'gallection/folders/update_order',
            data: params
        });
    }
}
export default moveGallectionToPosition;

//# sourceMappingURL=moveGallectionToPosition.js.map